import type {ReactNode} from 'react'
import css from './FormTitle.module.css'
import {TextNormBold} from "../../../Text";

interface FormTitleProps {
    children: ReactNode
}

const FormTitle = ({children}: FormTitleProps) => {
    return (
        <TextNormBold className={css.form_title}>{children}</TextNormBold>
    )
}

export default FormTitle
